import { useTranslation } from 'react-i18next'
import { StatusBadge } from '../../../../@ui/badges'

interface NodeTierStatusBadgeProps {
  activeTier?: {
    status?: string | null
  } | null
}

export const NodeTierStatusBadge = ({
  activeTier,
}: NodeTierStatusBadgeProps) => {
  const { t } = useTranslation('tiers')

  // Determine node tier status
  const getNodeTierStatus = () => {
    if (!activeTier) {
      return { label: t('payment-required'), status: 'payment-required' }
    }

    const status = activeTier.status?.toLowerCase()
    if (status === 'cancelled') {
      return { label: t('cancelled'), status: 'cancelled' }
    }
    if (status === 'pending_renovation') {
      return { label: t('pending-renovation'), status: 'pending_renovation' }
    }
    if (status === 'active') {
      return { label: t('active'), status: 'active' }
    }

    return { label: t('active'), status: 'active' }
  }

  const tierStatus = getNodeTierStatus()

  return <StatusBadge status={tierStatus.status} label={tierStatus.label} />
}
